// import HTTP from "../../utility/http";
// import { asyncHandler } from "@/utility/async";

const state = {
  ordersData: {
    startDate: "",
    endDate: "",
    orderId: "",
    email: "",
  },
  albumsData: {
    date: "",
    outfitter: "",
    section: "",
  },
};

const getters = {
  getOrdersData: (state) => {
    return state.ordersData;
  },
  getAlbumsData: (state) => {
    return state.albumsData;
  },
};

const actions = {
  set_orders_startDate({ commit }, startDate) {
    commit("set_orders_startDate", startDate);
  },
  set_orders_endDate({ commit }, endDate) {
    commit("set_orders_endDate", endDate);
  },
  set_orders_orderId({ commit }, orderId) {
    commit("set_orders_orderId", orderId);
  },
  set_orders_email({ commit }, email) {
    commit("set_orders_email", email);
  },
  set_albums_date({ commit }, date) {
    commit("set_albums_date", date);
  },
  set_albums_outfitter({ commit }, outfitter) {
    commit("set_albums_outfitter", outfitter);
  },
  set_albums_section({ commit }, section) {
    commit("set_albums_section", section);
  },
};

const mutations = {
  set_orders_startDate: (state, startDate) => {
    state.ordersData.startDate = startDate;
  },
  set_orders_endDate: (state, endDate) => {
    state.ordersData.endDate = endDate;
  },
  set_orders_orderId: (state, orderId) => {
    state.ordersData.orderId = orderId;
  },
  set_orders_email: (state, email) => {
    state.ordersData.email = email;
  },
  set_albums_date: (state, date) => {
    state.albumsData.date = date;
  },
  set_albums_outfitter: (state, outfitter) => {
    state.albumsData.outfitter = outfitter;
  },
  set_albums_section: (state, section) => {
    state.albumsData.section = section;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
